@if (notificationService.notifications().length > 0) {
    <div
        class="fixed bottom-24 right-4 z-50 flex w-[min(420px,calc(100vw-2rem))] flex-col gap-3 pointer-events-none"
        aria-live="polite"
        aria-atomic="true"
    >
        @for (notification of notificationService.notifications(); track notification.id) {
            <div class="pointer-events-auto flex items-start gap-2">
                <si-inline-notification
                    class="flex-1"
                    [severity]="notification.severity"
                    [heading]="notification.heading"
                    [message]="notification.message"
                />
            </div>
        }
    </div>
}
